import * as React from "react";
import {
    PlasmicInputFiled,
    DefaultInputFiledProps
} from "./plasmic/main/PlasmicInputFiled";
import {useEffect, useState} from "react";

export interface InputFiledProps extends DefaultInputFiledProps {
    defaultValue: string,
    onFinish: (name: string) => any,
    autoFocus: boolean,
    placeholder: string,
    finishOnBlur: boolean
}

function InputFiled({defaultValue, autoFocus, onFinish, placeholder, finishOnBlur, ...rest}: InputFiledProps) {
    const [text, setText] = useState<string>(defaultValue);

    useEffect(() => {
        setText(defaultValue);
    }, [defaultValue]);

    return <PlasmicInputFiled
        {...rest}
        input={{
            value: text,
            autoFocus: autoFocus,
            placeholder: placeholder,
            onChange: (e) => {
                setText(e.target.value);
            },
            onBlur: () => {
                finishOnBlur && onFinish && onFinish(text);
            },
            onKeyDown: (event: any) => {
                if (event.key === 'Enter') {
                    onFinish && onFinish(text);
                }
            }
        }}
    />;
}

export default InputFiled;
